import { AccordionButton } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';

const AccordionIconButton = styled(AccordionButton, { shouldForwardProp: (prop) => prop !== 'isEditing' })`
    width: auto;
    margin-left: 10px;
    margin-right: 4px;
    margin-top: ${(props) => props.isEditing && '20px'};
    border-radius: var(--chakra-radii-base);

    &:hover {
        background: none;
    }
`;

export default AccordionIconButton;
